import { render, staticRenderFns } from "./SallyTextarea.vue?vue&type=template&id=3a82fa02&scoped=true"
import script from "./SallyTextarea.vue?vue&type=script&lang=js"
export * from "./SallyTextarea.vue?vue&type=script&lang=js"
import style0 from "./SallyTextarea.vue?vue&type=style&index=0&id=3a82fa02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a82fa02",
  null
  
)

export default component.exports